import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {BenutzerRollenPage} from './benutzer-rollen.page';
import {StoreModule} from '@ngrx/store';
import {reducers} from './benutzer-rollen.reducer';
import {EffectsModule} from '@ngrx/effects';
import {
    BenutzerverwaltungBenutzerListeEffects,
    BenutzerverwaltungFunktionsbereicheRollenEffects,
    BenutzerverwaltungRolleBenutzerEffects,
    BenutzerverwaltungRolleBenutzerEntfernenEffects,
    BenutzerverwaltungRolleBenutzerHinzufuegenMultiEffects, BenutzerverwaltungRolleBenutzerTotalEffects
} from '../../../client-ngrx/benutzerverwaltung';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {EffectsWs} from './benutzer-rollen.effects.ws';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';

const routes: Routes = [
    {
        path: '',
        component: BenutzerRollenPage,
        data: { title: 'Benutzer und Rollen' }
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('BenutzerRollenPage', reducers),
        EffectsModule.forFeature([
            // UI
            EffectsWs,

            // GET
            BenutzerverwaltungBenutzerListeEffects,
            BenutzerverwaltungFunktionsbereicheRollenEffects,
            BenutzerverwaltungRolleBenutzerEffects,
            BenutzerverwaltungRolleBenutzerTotalEffects,

            // POST
            BenutzerverwaltungRolleBenutzerEntfernenEffects,
            BenutzerverwaltungRolleBenutzerHinzufuegenMultiEffects
        ]),
        SopiScrollModule,
        SopiComponentsModule.forRoot()
    ],
    providers: [],
    declarations: [BenutzerRollenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BenutzerRollenPageModule {
}
